module.exports = __webpack_public_path__ + "0fdd66a7178058ebf387cab247a45a4f.png";